import { formatRate } from 'utils/formatUtils';

export const STANDARD = {
  KEY: 'Standard' as LicenseType,
  RATE: 25,
  ITEMS: 5
};

export const ADVANCED = {
  KEY: 'Advanced' as LicenseType,
  RATE: 250,
  ITEMS: 10
};

export const DEDICATED = {
  KEY: 'Dedicated' as LicenseType,
  ITEMS: 20
};

export const getHint = (
  totalRate: number,
  itemCount: number,
  license: string
): string =>
  `Your total velocity was ${formatRate(
    totalRate
  )} and total number of items was ${itemCount}. Based on this at a minimum you would need the ${license} license.`;

export const getItemHint = (
  totalRate: number,
  itemCount: number,
  license: string
): string =>
  `Your total velocity was ${formatRate(
    totalRate
  )} and total number of items was ${itemCount}. <b>Due to the number of items, you will need additional item pack add-ons.</b> Based on this at a minimum you would need the ${license} license.`;

export const getRate = (
  features: number | null,
  timeUnit: TimeUnit | null,
  size: number
): number | null => {
  if (features === null || timeUnit === null) return null;
  switch (timeUnit) {
    case 'second':
      return features * size;
    case 'minute':
      return (features * size) / 60;
    case 'hour':
      return (features * size) / 60 / 60;
    default:
      return 0;
  }
};

export const getLicenseRecommendation: (
  totalRate: number | null,
  itemCount: number
) => LicenseRecommendation | null = (totalRate, itemCount) => {
  // Return null if total rate is not available
  if (totalRate === null) {
    return null;
  } else if (totalRate / 1024 <= STANDARD.RATE) {
    if (itemCount <= STANDARD.ITEMS) {
      return {
        type: STANDARD.KEY,
        hint: getHint(totalRate, itemCount, STANDARD.KEY)
      };
    } else if (itemCount <= ADVANCED.ITEMS) {
      return {
        type: ADVANCED.KEY,
        hint: getHint(totalRate, itemCount, ADVANCED.KEY)
      };
    } else {
      return {
        type: ADVANCED.KEY,
        hint: getItemHint(totalRate, itemCount, ADVANCED.KEY)
      };
    }
  } else if (totalRate / 1024 <= ADVANCED.RATE) {
    if (itemCount <= ADVANCED.ITEMS) {
      return {
        type: ADVANCED.KEY,
        hint: getHint(totalRate, itemCount, ADVANCED.KEY)
      };
    } else {
      return {
        type: ADVANCED.KEY,
        hint: getHint(totalRate, itemCount, ADVANCED.KEY)
      };
    }
  } else {
    if (itemCount <= DEDICATED.ITEMS) {
      return {
        type: DEDICATED.KEY,
        hint: getHint(totalRate, itemCount, DEDICATED.KEY)
      };
    } else {
      return {
        type: DEDICATED.KEY,
        hint: getItemHint(totalRate, itemCount, DEDICATED.KEY)
      };
    }
  }
};

export const getTotalRate: (
  config: CalculationConfig[]
) => number | null = configs => {
  // Return null if there is at least one config with missing rate
  if (configs.some(({ rate }) => rate === null)) return null;
  return configs.reduce((total, { rate }) => {
    return (total += rate!);
  }, 0);
};
